import styled, { css } from 'styled-components';

import { styledLayout, styledTypography } from '@pkg/primitives';

import { ChipColor, type ChipColorValue, ChipSize, type ChipSizeValue } from '../../Chip';
import { tokens as chipYatTokens } from '../ChipYat/tokens';

import { tokens } from './tokens';

interface ChipMemberInteriorProps {
    $color?: ChipColorValue;
    $size: ChipSizeValue;
    $spaceAroundYat?: boolean;
}

export const ChipMemberInterior = styled.div<ChipMemberInteriorProps>`
    --yat_chip-member-color: #fff;
    --yat_chip-member-bg-color: ${tokens.interior.background.default};
    --yat_chip-member-font-size: ${tokens.twitter.fontSize.smaller}px;
    --yat_chip-member-font-weight: ${tokens.twitter.fontWeight.default};

    --yat_chip-member-yat-margin-x: ${({ $spaceAroundYat }) =>
        $spaceAroundYat ? `${chipYatTokens.wrapper.gutter}px` : 0};
    --yat_chip-member-yat-height: ${({ $spaceAroundYat }) => ($spaceAroundYat ? 'auto' : '100%')};

    display: flex;
    align-items: center;
    max-width: 100%;
    height: 100%;
    border-radius: 999px;
    background: var(--yat_chip-member-bg-color);

    ${({ theme, $color }) => {
        if ($color === ChipColor.Active) {
            return css`
                --yat_chip-member-color: ${theme.colors.white};
                --yat_chip-member-bg-color: ${tokens.interior.background.active};
            `;
        }

        if ($color === ChipColor.BlurDark) {
            return css`
                --yat_chip-member-color: ${theme.colors.white};
                --yat_chip-member-bg-color: none;
                --yat_chip-member-font-weight: ${tokens.twitter.fontWeight.blurDark};
            `;
        }
    }};

    ${({ $size }) => {
        if ($size === ChipSize.Small) {
            return css`
                @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
                    --yat_chip-member-font-size: ${tokens.twitter.fontSize.small}px;
                }
            `;
        }

        if ($size === ChipSize.Medium) {
            return css`
                --yat_chip-member-font-size: ${tokens.twitter.fontSize.small}px;

                @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
                    --yat_chip-member-font-size: ${tokens.twitter.fontSize.medium}px;
                }
            `;
        }

        if ($size === ChipSize.Large) {
            return css`
                --yat_chip-member-font-size: ${tokens.twitter.fontSize.medium}px;

                @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
                    --yat_chip-member-font-size: ${tokens.twitter.fontSize.large}px;
                }
            `;
        }
    }};
`;

export const ChipYatWrapper = styled.div`
    display: grid;
    flex: 0 0 auto;
    margin-left: var(--yat_chip-member-yat-margin-x);
    margin-right: var(--yat_chip-member-yat-margin-x);
    height: var(--yat_chip-member-yat-height);
`;

export const TwitterHandleWrapper = styled.div`
    ${styledLayout.fullWidthFix};
    flex: 1 1 auto;
    padding-left: calc(var(--yat_chip-padding) / 2);
    padding-right: var(--yat_chip-padding);

    &:only-child {
        padding-left: var(--yat_chip-padding);
    }
`;
export const TwitterHandle = styled.span`
    ${styledTypography.truncate};
    ${styledTypography.allianceBase};
    display: block;
    line-height: var(--yat_chip-height);
    font-size: var(--yat_chip-member-font-size);
    font-weight: var(--yat_chip-member-font-weight);
    font-style: normal;
    text-align: left;
    text-shadow: -1px 1px 1px rgba(0, 43, 71, 0.3);
    color: var(--yat_chip-member-color);
`;
export const UsernameWrapper = styled.div`
    max-width: 140px;
    padding: 0 var(--yat_chip-padding);
    height: var(--yat_chip-height);
`;
